import { ValidationMessages } from "@/types/functions";

const validationEn: ValidationMessages = {
    'min_length': '{field} must have at least 0:{min} Elements selected',
    'max_length': '{field} must not have more than 0:{max} Elements selected',
    'multiple': 'Die {field} muss ein vielfaches von 0:{multiple} sein'
}

export default validationEn
